import { useRef, useCallback } from "react";

const STORAGE_KEY = "lastGlobalChatId";

/**
 * Single owner for the notification high-water mark.
 *
 * Reads the persisted value from localStorage once on mount and exposes:
 * - markRef: a stable ref to the current value (read in effects without causing re-renders)
 * - advance(id): update the mark and persist to localStorage only when id exceeds the current value
 *
 * Using a hook here ensures the localStorage read/write logic lives in exactly one place
 * and cannot be duplicated across multiple effects.
 */
export function useHighWaterMark() {
  const markRef = useRef<number>(
    parseInt(localStorage.getItem(STORAGE_KEY) ?? "0", 10)
  );

  const advance = useCallback((id: number) => {
    if (id > markRef.current) {
      markRef.current = id;
      localStorage.setItem(STORAGE_KEY, String(id));
    }
  }, []);

  return { markRef, advance };
}
